export const hasScroll = ({ element }: { element: HTMLElement }): boolean => {
  const hasHorizontalScrollbar = element.scrollWidth > element.clientWidth;
  const hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
  return hasHorizontalScrollbar || hasVerticalScrollbar;
};
